import React, { Suspense, useRef, useState } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";
import {
  commonText,
  permissionManagement,
  userManage
} from "../../../locales/en";
import PermissionManagementTable from "../../../components/table/all-tables/permissionmanagement/PermissionManagementTable";
import { CREATE_USER_PERMISSION, USER_PERMISSION } from "../../../route/paths";
import privateAxios from "../../../utils/axiosPrivate";
import { showToast, downloadFileFromResponse } from "../../../utils/utils";
import { showToastType } from "../../../utils/constants/appConstants";
import {
  getUserManagementPermissionsUploadURL,
  getUserManagementPermissionsDownloadURL
} from "../../../utils/constants/apiEndPoints";

const Permission = () => {
  const fileInputRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await privateAxios.get(
        getUserManagementPermissionsDownloadURL,
        {
          responseType: "arraybuffer"
        }
      );
      downloadFileFromResponse(response);
    } catch {
      showToast(permissionManagement?.downloadError, showToastType.error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    try {
      const response = await privateAxios.post(
        getUserManagementPermissionsUploadURL,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      if (response.status === 200 || response.status === 201) {
        showToast(
          response.data.message || permissionManagement?.uploadSuccess,
          showToastType.success
        );
      }
    } catch (error) {
      const message =
        error.response?.data?.message || permissionManagement?.uploadError;
      showToast(message, showToastType.error);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  return (
    <>
      <TablePagesTitle
        mainTitle={userManage?.mainTitle}
        content={permissionManagement?.content}
      />
      <input
        type="file"
        accept=".json"
        className="d-none"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <AccessPageAction
        subheading={permissionManagement?.subheading}
        alluser={USER_PERMISSION}
        allUserTitle={permissionManagement?.subheading}
        createuser={CREATE_USER_PERMISSION}
        createUserTitle={permissionManagement?.createPermission}
        showDownloadUpload
        onDownload={handleDownload}
        isDownloading={isDownloading}
        onUploadClick={handleUploadClick}
        isUploading={isUploading}
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-3 mb-3 mx-0">
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <PermissionManagementTable />
          </Suspense>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default Permission;
